"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetIsBatchActionInProgressSchema = exports.CreateBatchActionSchema = exports.createTraceDeleteBatchActionConfig = exports.TraceDeleteBatchActionConfigSchema = exports.TraceDeleteCursorSchema = exports.BatchActionQuerySchema = exports.ActionId = exports.BatchActionStatus = exports.BatchActionType = void 0;
const zod_1 = __importDefault(require("zod"));
const filters_1 = require("../../interfaces/filters");
const orderBy_1 = require("../../interfaces/orderBy");
const tableNames_1 = require("../../interfaces/tableNames");
const search_1 = require("../../interfaces/search");
var BatchActionType;
(function (BatchActionType) {
    BatchActionType["Create"] = "create";
    BatchActionType["Delete"] = "delete";
})(BatchActionType || (exports.BatchActionType = BatchActionType = {}));
var BatchActionStatus;
(function (BatchActionStatus) {
    BatchActionStatus["Queued"] = "QUEUED";
    BatchActionStatus["Processing"] = "PROCESSING";
    BatchActionStatus["Completed"] = "COMPLETED";
    BatchActionStatus["Failed"] = "FAILED";
    BatchActionStatus["Partial"] = "PARTIAL";
})(BatchActionStatus || (exports.BatchActionStatus = BatchActionStatus = {}));
var ActionId;
(function (ActionId) {
    ActionId["ScoreDelete"] = "score-delete";
    ActionId["DatasetDelete"] = "dataset-delete";
    ActionId["TraceDelete"] = "trace-delete";
    ActionId["TraceAddToAnnotationQueue"] = "trace-add-to-annotation-queue";
    ActionId["SessionAddToAnnotationQueue"] = "session-add-to-annotation-queue";
    ActionId["ObservationAddToAnnotationQueue"] = "observation-add-to-annotation-queue";
    ActionId["ObservationAddToDataset"] = "observation-add-to-dataset";
    ActionId["ObservationBatchEvaluation"] = "observation-run-batched-evaluation";
    ActionId["ExperimentCompare"] = "experiment-compare";
})(ActionId || (exports.ActionId = ActionId = {}));
const ActionIdSchema = zod_1.default.enum(ActionId);
exports.BatchActionQuerySchema = zod_1.default
    .object({
    filter: filters_1.singleFilterList.nullable(),
    orderBy: orderBy_1.orderBy,
    searchQuery: zod_1.default.string().optional(),
    searchType: zod_1.default.array(search_1.TracingSearchType).optional(),
    pathPrefix: zod_1.default.string().optional(),
    // Routes worker reads to the events table instead of the legacy tables.
    // The v4 events view declares it and the server validates the declaration;
    // otherwise createBatchActionJob snapshots the user's v4 beta flag.
    useEventsTable: zod_1.default.boolean().optional(),
})
    .refine(search_1.hasValidTracingSearchTypes, {
    message: search_1.TRACING_SEARCH_TYPE_REQUIRED_MESSAGE,
    path: ["searchType"],
});
const TraceDeleteUtcTimestampSchema = zod_1.default.iso.datetime();
exports.TraceDeleteCursorSchema = zod_1.default.object({
    timestamp: TraceDeleteUtcTimestampSchema,
    traceId: zod_1.default.string(),
    id: zod_1.default.string().optional(),
});
const TraceDeleteInFlightBatchSchema = zod_1.default.object({
    traceIds: zod_1.default.array(zod_1.default.string()),
    cursorAfter: exports.TraceDeleteCursorSchema,
    minTimestamp: TraceDeleteUtcTimestampSchema,
    maxTimestamp: TraceDeleteUtcTimestampSchema,
});
exports.TraceDeleteBatchActionConfigSchema = zod_1.default.object({
    version: zod_1.default.literal(1),
    source: zod_1.default.enum(["traces", "events"]),
    cutoffCreatedAt: TraceDeleteUtcTimestampSchema,
    failureCount: zod_1.default.number().int().nonnegative().default(0),
    inFlightBatch: TraceDeleteInFlightBatchSchema.nullable(),
});
const createTraceDeleteBatchActionConfig = (opts) => ({
    version: 1,
    source: opts.useEventsTable ? "events" : "traces",
    cutoffCreatedAt: opts.cutoffCreatedAt.toISOString(),
    failureCount: 0,
    inFlightBatch: null,
});
exports.createTraceDeleteBatchActionConfig = createTraceDeleteBatchActionConfig;
exports.CreateBatchActionSchema = zod_1.default.object({
    projectId: zod_1.default.string(),
    actionId: ActionIdSchema,
    targetId: zod_1.default.string().optional(),
    query: exports.BatchActionQuerySchema,
    tableName: zod_1.default.enum(tableNames_1.BatchTableNames),
});
exports.GetIsBatchActionInProgressSchema = zod_1.default.object({
    projectId: zod_1.default.string(),
    actionId: ActionIdSchema,
    tableName: zod_1.default.enum(tableNames_1.BatchTableNames),
});
